<template>
  <div class="customLayoutTabsContent" :style="'background-color:'+gobleStyle.contentBackgroundColor">
    <div class="layoutTabs">
      <div class="layoutTabsHeader">
        <template  v-for="(v,k) in data.items" :key="k">
            <div class=" themeActive" :class="{'active':active==k}" @click="active=k" v-if="v.params.is_show">{{v.params.title}}
          <div class="line" :style="'background-color:'+gobleStyle.themeColor"></div>
        </div>
        </template>
      </div>
      <div v-for="(v,k) in data.items" :key="v.type">
        <div class="layoutMain"  v-if="active==k">
            <component :is="v.type" :data="v"  :gobleStyle="gobleStyle" />
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import trace from "../trace/index";
import enterprise from "../enterprise/index";
import { ref,watch } from 'vue';
export default {
  components: { trace, enterprise },
  props: { gobleStyle: Object,data: Object },
  setup(props) {
    const active=ref(0)
    watch(props,(val, oldval) => {
      console.log(val)
      if(val.data.items[0].params.is_show == false){
        active.value = 1
      }
      if(val.data.items[1].params.is_show == false){
        active.value = 0
      }
    })
    return{
      active,
    }
  },
};
</script>

<style lang="less" scoped>
.customLayoutTabsContent {
  .layoutTabs {
    // background-color: #fff;
    border-radius: 6px;
    .layoutTabsHeader {
      width: 100%;
      height: 50px;
      display: flex;
      text-align: center;
      padding-top: 15px;
      > div {
        flex: 1;
        position: relative;
      }
      .active {
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #131313;
        .line {
          content: "";
          width: 20px;
          height: 4px;
          background: #4fa1fc;
          border-radius: 2px;
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }
    .layoutMain {
      padding: 15px 12px;
      img {
        width: 100%;
      }
    }
  }
}
</style>